/*
 * @Author: zd
 * @Date: 2023-10-01 02:10:50
 * @LastEditors: zd
 * @LastEditTime: 2023-12-01 13:35:01
 * @Description: 业务员关联接口
 */
import request from '@/utils/request.js'

// 业务员获取验证码
export function genCheckCode(data) {
  return request.post('/manager/genCheckCode',data);
}

// 业务员登录
export function managerLogin(data) {
  return request.post('/manager/login',data);
}

// 业务员获取其下客户列表
export function getManagerCustList(data) {
  return request.post('/manager/getManagerCustList',data);
}

// 业务员登录其下某客户
export function loginByManagerAndCustId(data) {
  return request.post('/manager/loginByManagerAndCustId',data);
}

// 默认登录
export function defaultLogin(data) {
  return request.post('/manager/default-login',data);
}
